var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('section',{staticClass:"landing-page-video"},[_c('div',{staticClass:"a-container"},[_c('a-video-card',{attrs:{"is-embeded":"","yt-id":_vm.content.ytId,"image":_vm.content.image,"text":_vm.content.title}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }